/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { Fragment } from 'react';

import { jsx } from '@emotion/react';

import { type StatusPanelProps } from '@af/design-system-docs-ui';

import BackToTop from '../__DO_NOT_ADD_TO_THIS_FOLDER__/gatsby-theme-brisk/components/back-to-top';
import FeedbackSection from '../__DO_NOT_ADD_TO_THIS_FOLDER__/gatsby-theme-brisk/components/feedback-analytics/feedback-section';
import Hero from '../__DO_NOT_ADD_TO_THIS_FOLDER__/gatsby-theme-brisk/components/hero';
import {
	mainContentStyles,
	spanAllHorizontalContentStyles,
} from '../__DO_NOT_ADD_TO_THIS_FOLDER__/gatsby-theme-brisk/components/layout';
import LocalNav from '../__DO_NOT_ADD_TO_THIS_FOLDER__/gatsby-theme-brisk/components/local-nav/local-nav';
import MetaTags from '../__DO_NOT_ADD_TO_THIS_FOLDER__/gatsby-theme-brisk/components/meta-tags';
import useMounted from '../hooks/is-mounted';

interface PageProps {
	title: string;
	description?: string;
	status?: StatusPanelProps;
	children: any;
	tabName?: string;
	guidelineCategory?: string;
	parentPageTitle?: string;
	subpageTabName?: string;
	shouldHideLocalNav?: boolean;
}

/**
 * __Page__
 */
const Page = ({
	subpageTabName,
	title,
	description,
	status,
	children,
	tabName,
	guidelineCategory,
	parentPageTitle,
	shouldHideLocalNav: hideLocalNav,
}: PageProps) => {
	const checkMounted = useMounted();
	const pageUrl = checkMounted ? window.location.href : '';

	return (
		<Fragment>
			<MetaTags
				title={title}
				description={description}
				tabName={tabName}
				guidelineCategory={guidelineCategory}
				parentPageTitle={parentPageTitle}
				subpageTabName={subpageTabName}
			/>
			<Hero
				css={{ gridArea: 'hero' }}
				headline={title}
				description={description ? description : ''}
				status={status}
			/>
			<div
				// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
				css={[mainContentStyles, hideLocalNav && spanAllHorizontalContentStyles]}
				//eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
				className="main-content"
			>
				{children}
				<FeedbackSection
					subpageTabName={subpageTabName}
					tabName={tabName}
					title={title}
					pageUrl={pageUrl}
				/>
			</div>
			<BackToTop label="Back to top" />
			{!hideLocalNav && <LocalNav />}
		</Fragment>
	);
};

export default Page;
